import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type ImportationDetailsTableMessages = TableColumnsMessages &
  PopoverMessages & {
    importationNotFoundError: string;
    importationNotFoundDescription: string;
    importationNotFoundAlt: string;
    importationErrorToLoad: string;
    importationTableTitle: string;
    codeColumn: string;
    nameColumn: string;
    statusColumn: string;
    messageColumn: string;
    optionsColumn: string;
  };

export const IMPORTATION_DETAILS_TABLE_MESSAGES: ImportationDetailsTableMessages = {
  ...TABLE_COLUMNS_MESSAGES,
  importationNotFoundError: "Importação não encontrada",
  importationNotFoundDescription: "Descrição da importação não encontrada",
  importationNotFoundAlt: "Importação não encontrada alternativa",
  importationErrorToLoad: "Erro ao carregar importações",
  importationTableTitle: "Listagem de Importações",
  codeColumn: "Código",
  nameColumn: "Nome",
  statusColumn: "Status",
  messageColumn: "Mensagem",
  optionsColumn: "Opções",
  ...POPOVER_MESSAGES,
};

export default IMPORTATION_DETAILS_TABLE_MESSAGES;
